import { CurrencyInput, InputValidation, Label } from "@components";
import PricingRecord, { PricingSettings } from "@models/PricingRecord";
import React from "react";
import { Col, FormGroup, Row } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { PricingCardProps } from "./IPricingCardProps";

export default function MinimumFeeSetting(props: PricingCardProps) {
	const { index, pricingSettings } = props;

	const pricingRecord: PricingRecord = pricingSettings[index];

	const { control } =
		useFormContext<{ pricingSettings: PricingSettings | null }>();

	const error =
		pricingRecord.yearlyBilling && pricingRecord.minimumFee != 0
			? {
					message:
						"Jährliche Vorauszahlung und Mindesthonorar sind inkompatibel",
			  }
			: undefined;

	return (
		<InputValidation error={error}>
			<FormGroup as={Row}>
				<Label column sm="3">
					Mindesthonorar (€)
				</Label>
				<Col style={{ marginLeft: 24 }} sm="5">
					<Controller
						control={control}
						name={`pricingSettings.${index}.minimumFee`}
						defaultValue={pricingRecord?.minimumFee || 0}
						rules={{
							required: true,
							min: 0.0,
							validate: () => !error,
						}}
						render={({ field }) => (
							<CurrencyInput
								placeholder="Bitte eintragen"
								{...field}
								min={0.0}
							/>
						)}
					/>
				</Col>
			</FormGroup>
		</InputValidation>
	);
}
